<template>
  <div id="google-signin-btn" ref="googleBtn"></div>
</template>

<script>
export default {
  name: 'GoogleLoginButton',
  props: {
    googleClientId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.loadGoogleIdentityServices();
  },
  methods: {
    loadGoogleIdentityServices() {
      if (window.google && window.google.accounts && window.google.accounts.id) {
        this.initGoogleSignIn();
      } else {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.onload = () => {
          this.initGoogleSignIn();
        };
        script.onerror = () => {
          this.$emit('error', new Error('Failed to load Google Identity Services script'));
        };
        document.head.appendChild(script);
      }
    },
    initGoogleSignIn() {
      try {
        window.google.accounts.id.initialize({
          client_id: this.googleClientId,
          callback: (response) => {
            this.$emit('success', response);
          }
        });
        window.google.accounts.id.renderButton(
          this.$refs.googleBtn,
          {
            theme: 'outline',
            size: 'large',
            type: 'standard',
            text: 'signin_with',
            shape: 'rectangular'
          }
        );
      } catch (error) {
        this.$emit('error', error);
      }
    }
  }
}
</script>

<style scoped>
#google-signin-btn {
  display: inline-block;
}
</style>